import type {
  ExtendedConstraints,
  CapabilityConfig,
  EventHandlerCb,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'play-sound';

export enum Events {
  PlayStatus = 'play-sound:play-status',
}

export enum Actions {
  Play = 'play-sound:play',
}

export type Config = CapabilityConfig & {
  type: typeof id;
};

export type PlayStatusPayload = {
  isSuccess: boolean;
  errorMessage?: string;
};

export type PlayConfig = {
  pan?: number;
  volume?: number;
};
export type PlayPayload = {
  source: ArrayBuffer;
  config?: PlayConfig;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.PlayStatus, PlayStatusPayload];
  eventHandlerTuple: [Events.PlayStatus, EventHandlerCb<PlayStatusPayload>];
  actionPayloadTuple: [Actions.Play, PlayPayload, Transferable[]];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
